<template>
  <nav class="header">
    <div class="container">
      <a href="https://www.reseau-colibri.fr">
        <img width="225" src="../assets/logo.png" alt="logo" />
      </a>

      <button
        v-if="route.name !== 'accueil'"
        class="btn_menu btn"
        type="button"
        @click="navOpen = !navOpen"
      >
        <span class="icon_menu"><i class="fas fa-bars fa-2x"></i></span>
      </button>

      <div v-if="route.name !== 'accueil'" class="liste_btn" :class="{ show: navOpen }">
        <router-link :to="{ name: 'accueil' }">
          <button class="btn_header btn">Accueil <i class="fas fa-arrow-right"></i></button>
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { ref } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const navOpen = ref(false)
</script>

<style lang="scss">
@import '../sass/app';

.header {
  margin-bottom: 3rem;
  background-color: $firstcolor;
  padding: 0.5rem 1rem;

  > .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .liste_btn {
    display: flex;

    @include media-breakpoint-down(md) {
      display: none;
      width: 100%;
      margin-top: 0.5rem;

      &.show {
        display: flex;
        justify-content: flex-end;
      }
    }

    .btn_header {
      color: $firstcolor;
      text-transform: uppercase;
      background-color: white;
      border-radius: 50px;
    }

    .btn_header:hover {
      color: white;
      background-color: $firstcolor;
      border: 1px solid white;
    }
  }

  .btn_menu {
    border-color: transparent !important;
    color: white !important;

    @include media-breakpoint-up(lg) {
      display: none;
    }
  }
}
</style>